import { render } from "./TiposCreditosList.vue?vue&type=template&id=798c8b32&scoped=true"
import script from "./TiposCreditosList.vue?vue&type=script&lang=js"
export * from "./TiposCreditosList.vue?vue&type=script&lang=js"

import "./TiposCreditosList.vue?vue&type=style&index=0&id=798c8b32&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798c8b32"]])

export default __exports__